import { LearningItemDto, LearningPathDto } from './dtos';
import { estimatedMinutesError } from './estimated-minutes';

export function formatLearningMinutes(minutes: number): string {
    const hours = Math.floor(minutes / 60);
    const rest = minutes % 60;
    return hours ? `${hours} h${rest ? ` ${rest} min` : ''}` : `${rest} min`;
}

export function remainingCourseTimes(path: LearningPathDto) {
    const lessons = new Map<string, { item: LearningItemDto; complete: boolean }>();
    const add = (item: LearningItemDto, complete: boolean) => {
        const previous = lessons.get(item.key);
        const parents = new Map([...(previous?.item.parentCourses ?? []), ...(item.parentCourses ?? [])].map(course => [course.key, course]));
        lessons.set(item.key, { item: { ...item, parentCourses: [...parents.values()] }, complete: complete || previous?.complete === true });
    };
    for (const item of [...path.available, ...path.inProgress, ...path.locked]) add(item, false);
    for (const item of path.completed) add(item, true);
    const courses = new Map<string, { key: string; title: string; total: number; completed: number; minutes: number; missing: number }>();
    let minutes = 0, missing = 0, remaining = 0;
    for (const { item, complete } of lessons.values()) {
        const known = item.estimated_minutes != null && !estimatedMinutesError(item.estimated_minutes);
        if (!complete) { remaining++; if (known) minutes += item.estimated_minutes!; else missing++; }
        for (const course of new Map((item.parentCourses ?? []).map(course => [course.key, course])).values()) {
            const entry = courses.get(course.key) ?? { key: course.key, title: course.title, total: 0, completed: 0, minutes: 0, missing: 0 };
            entry.total++;
            if (complete) entry.completed++;
            else if (known) entry.minutes += item.estimated_minutes!;
            else entry.missing++;
            courses.set(course.key, entry);
        }
    }
    return { minutes, missing, remaining, courses: [...courses.values()].sort((a, b) => a.title.localeCompare(b.title)) };
}
